module.exports = __webpack_public_path__ + "static/media/LAVADERIA PRATIC.34bea374.png";